<div class="flex flex-col gap-2">
  <ui-paragraph
    type="p14"
    font-weight="regular"
    text-color="neutrals-600"
    [content]="label"
  />
  <div class="relative">
    <div class="relative">
      <input
        type="text"
        class="w-full h-12 rounded-xl border border-neutrals-400 bg-neutrals-0 px-3 pr-9"
        placeholder="Seleccionar"
        [attr.aria-label]="label"
        [value]="query"
        (click)="onFieldClick()"
        (input)="onQueryInput($any($event.target).value)"
      />
      <ui-icon
        class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none"
        name="chevron-down"
        size="24"
        mobile-size="24"
        fill="primary-500"
      ></ui-icon>
    </div>

    <ul
      *ngIf="isOpen"
      class="absolute z-10 mt-1 w-full max-h-60 overflow-y-auto rounded-xl border border-neutrals-300 bg-neutrals-0 shadow-lg"
    >
      <li
        *ngFor="let option of filteredOptions; trackBy: trackById"
        class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-neutrals-100"
        (click)="toggleOption(option.id)"
      >
        <ui-checkbox
          class="pointer-events-none"
          [identifier]="'filter-option-' + option.id"
          [name]="'filter-option-' + option.id"
          [checked]="isSelected(option.id)"
        ></ui-checkbox>
        <div class="flex flex-col">
          <ui-paragraph
            type="p14"
            [attr.font-weight]="isSelected(option.id) ? 'semibold' : 'regular'"
            text-color="neutrals-900"
            [content]="option.name"
          />
          <ui-paragraph
            *ngIf="option.subDescription"
            type="p12"
            font-weight="regular"
            text-color="neutrals-600"
            [content]="option.subDescription"
          />
        </div>
      </li>
      <li *ngIf="filteredOptions.length === 0" class="px-3 py-2">
        <ui-paragraph
          type="p14"
          font-weight="regular"
          text-color="neutrals-600"
          content="Sin coincidencias"
        />
      </li>
    </ul>
  </div>

  <div class="flex flex-wrap gap-2" *ngIf="selectedOptions.length">
    <div
      *ngFor="let option of selectedOptions; trackBy: trackById"
      class="flex items-center gap-1 rounded-full bg-neutrals-200 px-3 py-1"
    >
      <ui-paragraph
        type="p12"
        font-weight="regular"
        text-color="neutrals-900"
        [content]="option.name"
      />
      <button
        type="button"
        [attr.aria-label]="'Quitar ' + option.name"
        (click)="removeChip(option.id)"
      >
        <ui-icon
          name="close"
          size="16"
          mobile-size="16"
          fill="neutrals-700"
        ></ui-icon>
      </button>
    </div>
  </div>
</div>
